export const MAX_FILE_SIZE_LIMIT = 1 * 1024 * 1024 // 1 MB

// Accpeted doc types PDF, DOC, PNG, JPG, JPEG, Excel, or CSV
export const ACCEPTED_FILE_TYPES = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'text/csv': ['.csv'],
  'image/png': ['.png'],
  'image/jpeg': ['.jpeg', '.jpg'],
}
